import React from "react";
import ViewModeIconToggle from "../ViewModeIconToggle";

/**
 * Standard CRUD list toolbar: search, optional middle slot (filters), CSV import, New, Delete, table/card.
 */
export default function CrudListToolbar({
  searchTerm,
  onSearchChange,
  searchPlaceholder,
  onClearSearch,
  middleSlot = null,
  extraActions = null,
  showCsvImport = true,
  showNew = true,
  showDelete = true,
  importPanelExpanded,
  onToggleImport,
  onNew,
  onDeleteSelected,
  deleteDisabled,
  deleteCountSuffix,
  viewMode,
  onViewModeChange,
  viewModeOptions,
  importOpenLabel = "− Import CSV",
  importClosedLabel = "+ Import CSV",
  showViewToggle = true,
  /** Rendered after the view toggle (e.g. inline `GlobalTimeNavigatorBar`). */
  trailingSlot = null,
  /**
   * When set with `trailingSlot`, the view toggle and trailing slot render on a **second** toolbar row
   * (e.g. Project: list/grid + time navigator). That row wraps on narrow viewports.
   */
  secondRowForViewAndTrailing = false,
}) {
  const hasTrailing = trailingSlot != null;
  const useSecondRow = secondRowForViewAndTrailing && showViewToggle && hasTrailing;

  const viewToggleEl = showViewToggle ? (
    <ViewModeIconToggle
      value={viewMode}
      onChange={onViewModeChange}
      modes={Array.isArray(viewModeOptions) && viewModeOptions.length > 0 ? viewModeOptions : ["table", "card"]}
      ariaLabel="View"
    />
  ) : null;

  return (
    <>
      <div className="toolbar">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          className="input input-search-260"
        />
        <button type="button" onClick={onClearSearch} className="btn btn-sm btn-secondary">
          Clear
        </button>
        <span className="toolbar-divider" />
        {middleSlot}
        {showCsvImport && (
          <>
            <button
              type="button"
              onClick={onToggleImport}
              className={`btn btn-md ${importPanelExpanded ? "btn-primary-outline active" : "btn-primary"}`}
            >
              {importPanelExpanded ? importOpenLabel : importClosedLabel}
            </button>
          </>
        )}
        {extraActions}
        {showNew && onNew ? (
          <button type="button" onClick={onNew} className="btn btn-md btn-primary">
            + New
          </button>
        ) : null}
        {showDelete && onDeleteSelected ? (
          <button type="button" onClick={onDeleteSelected} disabled={deleteDisabled} className="btn btn-danger">
            Delete{deleteCountSuffix}
          </button>
        ) : null}
        {!useSecondRow && showViewToggle && (
          <>
            <span className="toolbar-divider" />
            {viewToggleEl}
          </>
        )}
        {!useSecondRow && hasTrailing && (
          <>
            <span className="toolbar-divider" />
            {trailingSlot}
          </>
        )}
      </div>
      {useSecondRow ? (
        <div className="toolbar toolbar--view-trailing">
          {viewToggleEl}
          {trailingSlot}
        </div>
      ) : null}
    </>
  );
}
